"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFetch = void 0;
var tslib_1 = require("tslib");
var unfetch_1 = (0, tslib_1.__importDefault)(require("unfetch"));
function getFetch() {
    return typeof fetch === 'function' ? fetch : unfetch_1.default;
}
exports.getFetch = getFetch;
